import { render, staticRenderFns } from "./ModalCancelDelivery.vue?vue&type=template&id=ed012d58&scoped=true&"
import script from "./ModalCancelDelivery.vue?vue&type=script&lang=ts&"
export * from "./ModalCancelDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCancelDelivery.vue?vue&type=style&index=0&id=ed012d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed012d58",
  null
  
)

export default component.exports